import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { VigimareAlert } from '../../../models/vigimare-alert.model';

/**
 * Supplies the CISE/VIGIMARE XML behind an alert.
 *
 * The backend renders it from the stored model, so what the operator sees is exactly what
 * was exchanged — never a reconstruction.
 */
@Injectable({ providedIn: 'root' })
export class CyberXmlService {
  private http = inject(HttpClient);

  alertXml(alert: VigimareAlert): Observable<string> {
    return this.http.get(`${environment.apiBaseUrl}/vigimare-alerts/${alert.id}/xml`, {
      responseType: 'text',
    });
  }
}
